import React from 'react';

type VariousSmartPricingIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const VariousSmartPricingIcon = ({
  width = 22,
  height = 29,
}: VariousSmartPricingIconProps) => (
  <svg width={width} height={height} viewBox="0 0 22 29" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient x1="25.615%" y1="10.262%" x2="76.008%" y2="89.383%" id="a">
        <stop stopColor="#3023AE" offset="0%" />
        <stop stopColor="#C86DD7" offset="100%" />
      </linearGradient>
    </defs>
    <path fill="url(#a)" d="M11.001 0L0 14.5 11.001 29 22 14.5z" fillRule="evenodd" />
  </svg>
);
